import { hasActiveOwnerPortal } from '@vrplatform/data';

/**
 * Resolved when the Clerk provider mounts, after any owner portal bootstrap.
 * A customer hostname uses the production instance only once its registration
 * validated; an unrecognised hostname keeps the development key.
 */
export function getClerkPublishableKey() {
  const { hostname } = window.location;
  const isPlatformHost = (domain: string) =>
    hostname === domain || hostname.endsWith(`.${domain}`);
  if (isPlatformHost('finalytic.io'))
    return 'pk_live_Y2xlcmsuZmluYWx5dGljLmlvJA'; // Finalytic prod key
  if (isPlatformHost('vrplatform.app') || hasActiveOwnerPortal())
    return 'pk_live_Y2xlcmsudnJwbGF0Zm9ybS5hcHAk'; // VRP prod key
  return 'pk_test_Y2xlcmsuc2luY2VyZS5nb2JibGVyLTc2LmxjbC5kZXYk'; // dev key
}
